import Spacing from "@irati/ui/src/Spacing"
import {H2} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import React from "react"
import {ProductCard} from "../../components/ProductCard"
import Slider from "@irati/ui/src/Slider"
import {DESKTOP, LARGE_DESKTOP, PHONE, PHONE_LANDSCAPE, EXTRA_LARGE_DESKTOP} from "@irati/ui/src/global/media"
import {usePopularBikesQuery} from "@irati/payrollpay/hooks"
import {useStoreContext} from "../../context/StoreContext"
import Loading from "@irati/ui/src/Loading"

interface PopularBike {
  name: string
  image: string
  price: number
  url: string
}

const responsive = [
  {breakpoint: PHONE - 1, settings: {slidesToShow: 1.4, slidesToScroll: 1}},
  {breakpoint: PHONE_LANDSCAPE - 1, settings: {slidesToShow: 1.5, slidesToScroll: 1}},
  {breakpoint: DESKTOP - 1, settings: {slidesToShow: 2.2, slidesToScroll: 1}},
  {breakpoint: LARGE_DESKTOP - 1, settings: {slidesToShow: 3.2, slidesToScroll: 1}},
  {breakpoint: EXTRA_LARGE_DESKTOP - 1, settings: {slidesToShow: 3.5, slidesToScroll: 1}}
]

const sliderSettings = {
  responsive
}

export const PopularBikes = () => {
  const {schemeType} = useStoreContext()
  const scheme = {schemeType}
  const {data, load} = usePopularBikesQuery(scheme, {
    fetchPolicy: "cache-and-network"
  })

  const popularBikes = (data?.employeeOrganisation?.scheme as any)?.popularBikes

  return (
    <Loading load={load}>
      <Spacing marginTop={6} marginBottom={6}>
        <H2 marginBottom={1.5}>
          <FormattedMessage id="platform.payrollpay.store.landing.c2w.popularBikes.title" />
        </H2>
        <Slider settings={sliderSettings} slidesToShow={4.6}>
          {popularBikes &&
            popularBikes.map(({name, image, price, url}: PopularBike) => {
              return <ProductCard name={name} image={image} price={price} url={url} isCarousel={true} />
            })}
        </Slider>
      </Spacing>
    </Loading>
  )
}
